<template>
    <div class="gs-express-checkout">
        <div class="gs-express-checkout__choices">
            <button
                v-for="checkoutType in expressCheckoutTypes"
                :key="checkoutType.id"
                type="button"
                class="gs-express-checkout__choice"
                :class="{ 'is-selected': localModel.checkout_page_options.express_checkout == checkoutType.id }"
                @click="localModel.checkout_page_options.express_checkout = checkoutType.id"
            >
                <span class="gs-express-checkout__radio"></span>
                <strong>{{ checkoutType.title }}</strong>
                <em>{{ checkoutType.description }}</em>
            </button>
        </div>
        <aside class="gs-express-checkout__note">
            <div class="gs-express-checkout__browser">
                <CheckoutPage class="max-w-full" />
            </div>
            <h4>{{ selectedOptionTitle }}</h4>
            <p>{{ selectedOptionDescription }}</p>
        </aside>
    </div>
</template>
<script>
import CheckoutPage from '@/assets/images/pages/checkout-page.svg';

export default {
    components: {
        CheckoutPage
    },
    props: {
        model: {
            required: true
        },

    },
    data() {
        return {
            localModel: this.model,
            expressCheckoutTypes: [
                {
                    id: 0,
                    title: this.$t('frontend_product_step5_express_checkout_types0_title'),
                    description: this.$t('frontend_product_step5_express_checkout_types0_desc'),
                },
                {
                    id: 1,
                    title: this.$t('frontend_product_step5_express_checkout_types1_title'),
                    description: this.$t('frontend_product_step5_express_checkout_types1_desc'),
                },
                {
                    id: 2,
                    title: this.$t('frontend_product_step5_express_checkout_types2_title'),
                    description: this.$t('frontend_product_step5_express_checkout_types2_desc'),
                },
            ],
        }
    },
    watch: {
        localModel: {
            handler() {
                this.$emit('updateModel', this.localModel);
            },
            deep: true
        }
    },
    computed: {
        selectedOption() {
            return this.expressCheckoutTypes.find((option) => {
                return option.id == this.localModel.checkout_page_options.express_checkout;
            }) || this.expressCheckoutTypes[0];
        },
        selectedOptionTitle() {
            return this.selectedOption ? this.selectedOption.title : '';
        },
        selectedOptionDescription() {
            return this.selectedOption ? this.selectedOption.description : '';
        },
    },
}
</script>
<style>
.gs-express-checkout {
    display: grid;
    grid-template-columns: minmax(260px, 360px) minmax(0, 1fr);
    gap: 24px;
}

.gs-express-checkout__choices {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.gs-express-checkout__choice {
    position: relative;
    display: grid;
    grid-template-columns: 22px minmax(0, 1fr);
    column-gap: 12px;
    row-gap: 5px;
    padding: 16px;
    text-align: left;
    background: #ffffff;
    border: 1px solid var(--gs-border);
    border-radius: var(--gs-radius-md);
    box-shadow: var(--gs-shadow-sm);
}

.gs-express-checkout__choice.is-selected {
    background: var(--gs-active-soft);
    border-color: var(--gs-active);
    box-shadow: 0 0 0 3px var(--gs-active-shadow), var(--gs-shadow-sm);
}

.gs-express-checkout__radio {
    display: block;
    width: 18px;
    height: 18px;
    margin-top: 1px;
    border: 2px solid var(--gs-border-strong);
    border-radius: 999px;
}

.gs-express-checkout__choice.is-selected .gs-express-checkout__radio {
    border-color: var(--gs-active);
    box-shadow: inset 0 0 0 4px #ffffff;
    background: var(--gs-active);
}

.gs-express-checkout__choice strong {
    color: var(--gs-foreground);
    font-size: 15px;
    font-weight: 600;
    line-height: 1.35;
}

.gs-express-checkout__choice em {
    grid-column: 2;
    color: var(--gs-muted-foreground);
    font-size: 14px;
    font-style: normal;
    line-height: 1.45;
}

.gs-express-checkout__note {
    padding: 18px;
    background: var(--gs-surface-subtle);
    border: 1px solid var(--gs-border);
    border-radius: var(--gs-radius-sm);
}

.gs-express-checkout__browser {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 230px;
    margin-bottom: 18px;
    overflow: hidden;
    background: #ffffff;
    border: 1px solid var(--gs-border);
    border-radius: var(--gs-radius-md);
}

.gs-express-checkout__note h4 {
    margin: 0;
    color: var(--gs-foreground);
    font-size: 17px;
    font-weight: 600;
}

.gs-express-checkout__note p {
    margin: 8px 0 0;
    color: var(--gs-muted-foreground);
    font-size: 14px;
    line-height: 1.5;
}

@media (max-width: 860px) {
    .gs-express-checkout {
        grid-template-columns: 1fr;
    }
}
</style>
